(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
if (!window.__slideStaggerInit) {
  window.__slideStaggerInit = true;
  const groups = new Map();
  document.querySelectorAll('.slideshow--with-hints .slide__image-container').forEach((el) => {
    const section = el.closest('.slideshow-section') || el.closest('.section');
    if (!section) return;
    if (!groups.has(section)) groups.set(section, []);
    groups.get(section).push(el);
  });
  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const items = groups.get(entry.target) || [];
        items.forEach((el, i) => {
          setTimeout(() => el.classList.add('stagger-in'), i * 140);
        });
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.2 });
  groups.forEach((items, section) => io.observe(section));
}

  } catch(e) { console.error(e); }
})();
})();
